import { Component, Input } from '@angular/core';
import { AnswerInfo } from 'src/app/models/models';
import { Form, Response } from 'src/app/models/RestModels';

/**
 * Muestra una respuesta de formulario (question/answer) en modo lectura.
 * Se usa en view-quote y view-quote/view-order para visualizar los
 * formularios capturados en la cabecera y en los items.
 */
@Component({
	selector: 'app-form-response-viewer',
	templateUrl: './form-response-viewer.component.html',
	styleUrls: ['./form-response-viewer.component.css']
})
export class FormResponseViewerComponent
{
	@Input() response: Response | null | undefined = null;
	@Input() form: Form | null | undefined = null;
	@Input() answers: AnswerInfo[] | undefined = [];

	get sorted_answers(): AnswerInfo[]
	{
		return (this.answers || []).slice().sort((a,b)=> b.question.priority - a.question.priority);
	}

	getAnswerValue(ai: AnswerInfo): string
	{
		if( ai.answer?.answer_text )
			return ai.answer.answer_text;

		if( ai.answer?.answer_number != null && ai.answer?.answer_number !== undefined )
			return String(ai.answer.answer_number);

		return '—';
	}
}
